// @ts-nocheck
import React from 'react'
import { observer } from 'mobx-react-lite'
import { Redirect, Route, Switch } from 'react-router-dom'
import { ContentLayout } from 'shared/layout'
import { LayoutSidebar } from 'shared/layout/sidebar/LayoutSidebar'
import { AreaRelatedInit } from 'AreaRelatedInit'
import { CurrentUser } from 'auth/components/CurrentUser'
import { LayoutSidebarSection } from 'shared/layout/sidebar/LayoutSidebarSection'
import ProductsPage from 'modules/shared/products/products.page'
import WarehousePage from 'modules/shared/warehouse/warehouse.page'
import SalePointListPage from 'modules/shared/sale-point-list.page'
import ProductCategoryListPage from 'modules/shared/product-category-list.page'
import { AreaDataResolver } from 'features/area/area-resolver'

import MembersListPage from 'modules/shared/members-list/members-list.page'
import MemberProfilePage from 'modules/shared/member-profile/member-profile.page'
import EditBatchPage from 'modules/shared/batch-edit/edit-batch.page'

import { GoToMemberProfileFeature } from 'features/go-to-member-profile/go-to-member-profile.feature'
import { DispensaryNavigationMenu } from './DispensaryNavigationMenu'
import CashierPage from '../pages/cashier-page/cashier.page'
import { WarehouseJournalPage } from '../../admin/pages/warehouse-journal.page'
import { WarehouseRevisionPage } from '../../shared/warehouse-revisions/warehouse-revision.page'
import { WarehouseRevisionEditPage } from '../../shared/warehouse-revisions/warehouse-revision-edit.page'
import AddMemberPage from '../../shared/add-member-page/add-member.page'
import EditMemberPage from '../../shared/add-member-page/edit-member.page'
import { getPagePath } from '../../../router/utils'
import ProductEditPage from '../pages/product-edit.page'
import ProductCategoryEditPage from '../../owner/pages/product-category-edit.page'
import WarehouseClosedStockPage from "../../shared/warehouse/warehouse-closed-stock.page";


export const DispensaryRoutes: React.FC = observer(() => {
  const path = getPagePath('dispensary')

  return (
    <AreaDataResolver>
      <AreaRelatedInit>
        <ContentLayout
          sidebar={
            <LayoutSidebar>
              <LayoutSidebarSection profile>
                <CurrentUser />
              </LayoutSidebarSection>
              <LayoutSidebarSection>
                <GoToMemberProfileFeature />
              </LayoutSidebarSection>
              <LayoutSidebarSection fullHeight>
                <DispensaryNavigationMenu />
              </LayoutSidebarSection>
            </LayoutSidebar>
          }
        >
          <Switch>
          <Route path={`${path}`} exact>
              <Redirect to={`${path}/cashier`} />
            </Route>

            <Route path={`${path}/search`}>
              <MembersListPage />
            </Route>

            <Route path={`${path}/members/edit`} exact>
              <AddMemberPage />
            </Route>

            <Route path={`${path}/members/edit/:id`}>
              <EditMemberPage />
            </Route>

            <Route path={`${path}/members/:id`}>
              <MemberProfilePage />
            </Route>

            <Route path={`${path}/products/list`}>
              <ProductsPage />
            </Route>

            <Route path={`${path}/products/edit/:id`}>
              <ProductEditPage />
            </Route>

            <Route path={`${path}/warehouse`} exact>
              <WarehousePage />
            </Route>

            <Route path={`${path}/warehouse/closed`} exact>
              <WarehouseClosedStockPage />
            </Route>

            <Route path={`${path}/warehouse/:id`}>
              <EditBatchPage />
            </Route>

            <Route path={`${path}/product-categories/list`}>
              <ProductCategoryListPage />
            </Route>

            <Route path={`${path}/product-categories/edit/:id`}>
              <ProductCategoryEditPage />
            </Route>

            <Route path={`${path}/sale-points/list`}>
              <SalePointListPage />
            </Route>

            <Route path={`${path}/cashier`} exact>
              <CashierPage />
            </Route>

            <Route path={`${path}/cashier/orders`}>
              <WarehouseJournalPage />
            </Route>

            <Route path={`${path}/warehouse-revisions`} exact>
              <WarehouseRevisionPage />
            </Route>

            <Route path={`${path}/warehouse-revisions/:id`} exact>
              <WarehouseRevisionEditPage />
            </Route>

            <Route path="*">Page not found</Route>
          </Switch>
        </ContentLayout>
      </AreaRelatedInit>
    </AreaDataResolver>
  )
})
